import * as React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import MainLayout from 'src/components/layout/MainLayout';
import { useTitleStore } from 'src/stores/useTitleStore';
import { userMessages } from 'src/features/users/utils/messages';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'src/registry/ui/Tabs';
import { Outlet } from 'react-router-dom';
import UsersTable from 'src/features/users/components/tables/UsersTable';
import DeactivatedUsersTable from 'src/features/users/components/tables/DeactivatedUsersTable';
import { InvitationTable } from 'src/features/users/components/tables/InvitationTable';

const UsersLayout = () => {
    const { formatMessage } = useIntl();

    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        setTitle(formatMessage(userMessages.users));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return (
        <MainLayout>
            <Tabs defaultValue="users">
                <TabsList>
                    <TabsTrigger value="users">
                        <FormattedMessage {...userMessages.users} />
                    </TabsTrigger>

                    <TabsTrigger value="deactivated">
                        <FormattedMessage {...userMessages.deactivated} />
                    </TabsTrigger>

                    <TabsTrigger value="invitations">
                        <FormattedMessage {...userMessages.invitations} />
                    </TabsTrigger>
                </TabsList>

                <TabsContent value="users">
                    <UsersTable />
                </TabsContent>

                <TabsContent value="deactivated">
                    <DeactivatedUsersTable />
                </TabsContent>

                <TabsContent value="invitations">
                    <InvitationTable />
                </TabsContent>
            </Tabs>
            <Outlet />
        </MainLayout>
    );
};

export default UsersLayout;
